module.exports = __webpack_public_path__ + "9deed7e1f8e77c522254828708912d7f-nei_home_50_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/home/assets/nei_home_50_2x.png
// module id = 699
// module chunks = 0